<div class="fade modal modal-static pg-show-modal" id="modal-apply-job" tabindex="-1" role="dialog" aria-hidden="true"
    data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body mgn-top-15">
                <div class="col-12 ">
                    <div id="carousel-application" class="carousel slide" data-interval="false" data-keyboard="false">
                        <div class="carousel-inner transition-carousel-inner">
                            <div class="carousel-item"
                                *ngIf="employeeCriminalRecord.enabled || employeeWwcRecord.enabled || employeeEnglishLevel.enabled || employeeForeign.enabled">

                                <legend class="legend-style-1 legend-primary">
                                    Datos del perfil
                                </legend>

                                <div class="alert alert-warning d-flex font-size-13 mgn-bottom-25 text-dark">
                                    <div class="mgn-rigth-12"><i class="pj-ico pj-ico-170 pj-ico-info text-primary"></i>
                                    </div>
                                    <div>Para continuar con la postulación debes completar los siguientes campos
                                        asociados a tu perfil.</div>
                                </div>

                                <small class="form-text mgn-bottom-25 text-muted text-right">(*) campos
                                    obligatorios.</small>

                                <fieldset [formGroup]="_formGroupProfile" class=" mgn-bottom-25 ">

                                    <div class="row">
                                        <div class="col-12">
                                            <div class="form-row" *ngIf="employeeForeign.enabled">

                                                <div class="col-12 col-lg-6 col-sm-6">
                                                    <div class="form-group">
                                                        <span id="teacher-foreign-edit-label" class="label">¿Eres
                                                            extranjero?</span>
                                                        <div class="mgn-bottom-8 switch-label">
                                                            <label class="switch">
                                                                <input class="collapse-control-input" id="input-foreign"
                                                                    type="checkbox" name="employeeForeign"
                                                                    formControlName="employeeForeign" />
                                                                <span class="slider round"></span>
                                                            </label>
                                                            <div class="label">
                                                                {{employeeForeign.value===true?'Si':'No'}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-12 col-lg-6 col-sm-6"
                                                    *ngIf="employeeForeign.value === true">
                                                    <form-group-select-search [id]="'input-nacionality'"
                                                        [dropdownParent]="'modal-apply-job'" [title]="'Nacionalidad'"
                                                        [placeholder]="'Seleccione un país'"
                                                        [control]="employeeNacionality" [dataSelect]="COUNTRY_LIST"
                                                        [messageRequired]="'País es requerido.'">
                                                    </form-group-select-search>
                                                </div>

                                            </div>
                                            <div class="form-row">

                                                <div class="col-12 col-lg-6 col-sm-6"
                                                    *ngIf="employeeCriminalRecord.enabled">
                                                    <form-group-upload-box #inputCriminalRecord
                                                        (eventFileUpload)="onEventFileUpload($event)"
                                                        [control]="employeeCriminalRecord" [id]="'input-criminalRecord'"
                                                        [title]="'Certificado de antecedentes'"
                                                        [messageRequired]="'Certificado de antecedentes es requerido'"
                                                        [placeholder]="'Adjunta tu certificado'"
                                                        [popoverContent]="'<div>Puedes obtenerlo en: <a class=\'font-weight-bold white-link\' href=\'https:\/\/www.registrocivil.cl/principal/servicios-en-linea\' target=\'_blank\'>https://www.registrocivil.cl/principal/servicios-en-linea</a></div>'"
                                                        [type]="'criminal_record'">
                                                    </form-group-upload-box>
                                                </div>

                                                <div class="col-12 col-lg-6 col-sm-6" *ngIf="employeeWwcRecord.enabled">

                                                    <form-group-upload-box #inputWwcRecord [control]="employeeWwcRecord"
                                                        (eventFileUpload)="onEventFileUpload($event)"
                                                        [id]="'input-wwcRecord'"
                                                        [title]="'Certificado de Inhabilidades'"
                                                        [messageRequired]="'Certificado de Inhabilidades es requerido'"
                                                        [placeholder]="'Adjunta tu certificado'"
                                                        [popoverContent]="'<div>Puedes obtenerlo en: <a class=\'font-weight-bold white-link\' href=\'https:\/\/inhabilidades.srcei.cl/ConsInhab/consultaInhabilidad.do\' target=\'_blank\'>https://inhabilidades.srcei.cl/ConsInhab/consultaInhabilidad.do</a></div>'"
                                                        [type]="'wwc_record'">
                                                    </form-group-upload-box>

                                                </div>

                                            </div>



                                            <div class="form-row" *ngIf="employeeEnglishLevel.enabled">
                                                <div class="col-12 col-lg-6 col-sm-6">
                                                    <form-group-select [control]="employeeEnglishLevel"
                                                        [id]="'input-englishLevel'"
                                                        [title]="'¿Cuál es tu nivel de idioma inglés?'"
                                                        [dataSelect]="LANGUAGE_LEVEL"
                                                        [messageRequired]="'Nivel de idioma inglés es requerido.'"
                                                        [enabledDefaultOption]="false">
                                                    </form-group-select>
                                                </div>

                                                <div class="col-12 col-lg-6 col-sm-6"
                                                    [class.d-none]="!(+employeeEnglishLevel.value > 0)">

                                                    <form-group-upload-box #inputEnglishDocument
                                                        [control]="employeeEnglishDocument"
                                                        [id]="'input-englishDocument'" [title]="'Certificado de Inglés'"
                                                        [messageRequired]="'Certificado es requerido'"
                                                        [placeholder]="'Adjunta tu certificado'"
                                                        [type]="'inputEmployeeLanguage'">
                                                    </form-group-upload-box>

                                                </div>

                                            </div>


                                        </div>
                                    </div>


                                </fieldset>
                                <div class="form-row">
                                    <div class="col-12 text-center space-items-15">

                                        <button class="btn btn-link" type="button"
                                            data-dismiss="modal">Cancelar</button>

                                        <button class="btn btn-primary" (click)="validateStepProfile($event)"
                                            type="button">Continuar</button>
                                    </div>
                                </div>
                            </div>


                            <div class="carousel-item" *ngIf="remainingReference > 0">

                                <legend class="legend-style-1 legend-primary">
                                    Indicar referencia laboral <ng-conainer *ngIf="remainingReference === 2">(1 de
                                        2)</ng-conainer>
                                </legend>

                                <div class="alert alert-warning d-flex font-size-13 mgn-bottom-25 text-dark">
                                    <div class="mgn-rigth-12"><i class="pj-ico pj-ico-170 pj-ico-info text-primary"></i>
                                    </div>
                                    <div *ngIf="remainingReference === 1">Para postular debes agregar una referencia
                                        laboral.</div>
                                    <div *ngIf="remainingReference === 2">Para postular debes agregar dos referencias
                                        laborales.
                                    </div>
                                </div>

                                <small class="form-text mgn-bottom-25 text-muted text-right">(*) campos
                                    obligatorios.</small>

                                <form-employee-reference #formReference1 [sufix]="'f1'"
                                    (eventSaveRecord)="nextStepCarousel()"></form-employee-reference>

                                <div class="form-row">
                                    <div class="col-12 text-center space-items-15">

                                        <button class="btn btn-link" type="button"
                                            data-dismiss="modal">Cancelar</button>

                                        <button *ngIf="activeButtonBackReference" class="btn btn-outline-primary"
                                            type="button" (click)="prevStepCarousel()">Volver atrás</button>

                                        <button class="btn btn-primary"
                                            [attr.disabled]="formReference1.isLoadingRequest === true ? true : null"
                                            (click)="formReference1.addReference($event)"
                                            type="button">Continuar</button>
                                    </div>
                                </div>
                            </div>

                            <div class="carousel-item" *ngIf="remainingReference > 1">

                                <legend class="legend-style-1 legend-primary">Referencia laboral (2 de 2)
                                </legend>


                                <div class="alert alert-warning d-flex font-size-13 mgn-bottom-25 text-dark">
                                    <div class="mgn-rigth-12"><i class="pj-ico pj-ico-170 pj-ico-info text-primary"></i>
                                    </div>
                                    <div>Para postular debes agregar dos referencias laborales.</div>
                                </div>
                                <small class="form-text mgn-bottom-25 text-muted text-right">(*) campos
                                    obligatorios.</small>


                                <form-employee-reference #formReference2 [sufix]="'f2'"
                                    (eventSaveRecord)="nextStepCarousel()"></form-employee-reference>

                                <div class="form-row">
                                    <div class="col-12 text-center space-items-15">

                                        <button class="btn btn-link" type="button"
                                            data-dismiss="modal">Cancelar</button>

                                        <button class="btn btn-outline-primary" type="button"
                                            (click)="prevStepCarousel()">Volver atrás</button>

                                        <button class="btn btn-primary"
                                            [attr.disabled]="formReference2.isLoadingRequest === true ? true : null"
                                            (click)="formReference2.addReference($event)"
                                            type="button">Continuar</button>
                                    </div>
                                </div>

                            </div>

                            <div class="carousel-item">

                                <div class="row mgn-top-15">
                                    <div class="col-12 text-center">
                                        <i
                                            class="d-inline-block font-size-76 mgn-bottom-15 pj-ico pj-ico-triangulo-alerta text-primary"></i>
                                        <h4 class="custom-heading-modal-body mgn-bottom-25 text-primary">
                                            Importante<br><span class="font-size-18 font-weight-normal text-dark">Si
                                                postulas y no respondes a los reclutadores,
                                                podrías ser etiquetado negativamente, afectando futuras postulaciones.
                                                Si deseas
                                                retirar la postulación, notifícalo en "Mis postulaciones" o a los
                                                reclutadores.</span></h4>
                                        <p class="font-size-14 mgn-bottom-25 text-dark">
                                    </div>
                                </div>

                                <div class="form-row">
                                    <div class="col-12 text-center">
                                        <div class="form-group">
                                            <label class="checkbox-label font-size-14 mgn-bottom-10 "
                                                for="agree">
                                                &nbsp;He leído y comprendido este aviso.
                                                <input id="agree" type="checkbox" name="" [(ngModel)]="isTextRead">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>


                                <div class="form-row">
                                    <div class="col-12 text-center space-items-15">

                                        <button class="btn btn-link" type="button"
                                            data-dismiss="modal">Cancelar</button>

                                        <button *ngIf="activeButtonBackJobAddress" class="btn btn-outline-primary"
                                            type="button" (click)="prevStepCarousel()">Volver atrás</button>

                                        <button *ngIf="isTextRead === true" class="btn btn-primary"
                                            (click)="nextStepCarousel()" type="button">Continuar</button>

                                        <button [class.d-none]="isTextRead === true" data-toggle="popover"
                                            data-placement="top" data-html="true" data-trigger="hover"
                                            data-content="Asegúrate de leer el mensaje y marcar la casilla para seguir avanzando."
                                            class="btn btn-primary opacity-65" type="button">Continuar</button>
                                    </div>
                                </div>
                            </div>

                            <div class="carousel-item" *ngIf="dataAddressSelect.length > 1">


                                <legend class="legend-style-1 legend-primary">
                                    Comuna de postulación
                                </legend>

                                <div class="alert alert-warning d-flex font-size-13 mgn-bottom-25 text-dark">
                                    <div class="mgn-rigth-12"><i class="pj-ico pj-ico-170 pj-ico-info text-primary"></i>
                                    </div>
                                    <div>La
                                        postulación al anuncio
                                        <strong>{{jobTitle ? jobTitle : jobPosition}}<ng-container
                                                *ngIf="jobGradeFrom">, {{jobGradeFrom}}<ng-container
                                                    *ngIf="jobGradeFrom !== jobGradeTo"> a {{jobGradeTo}}</ng-container>
                                            </ng-container>
                                        </strong> tiene
                                        más de una comuna para elegir por lo cual deberás seleccionar a
                                        que comuna deseas
                                        postular.
                                    </div>
                                </div>
                                <small class="form-text mgn-bottom-25 text-muted text-right">(*) campos
                                    obligatorios.</small>

                                <fieldset [formGroup]="_formGroupAddress" class=" mgn-bottom-25">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="form-row" *ngIf="dataAddressSelect?.length > 0">
                                                <div class="col-12">
                                                    <div class="form-group" id="fg-input-address">
                                                        <label for="school-location-publish">Quiero postular en
                                                            la comuna
                                                            de (*)</label>
                                                        <ng-select2 [data]="dataAddressSelect"
                                                            [options]="constantsService.optionsSelect2MultipleWithoutTag"
                                                            [dropdownParent]="'fg-input-address'"
                                                            formControlName="applicationAddress">
                                                        </ng-select2>
                                                        <div class="invalid-feedback d-block"
                                                            *ngIf="applicationAddress.touched && applicationAddress.invalid">
                                                            <div *ngIf="applicationAddress.errors.required">
                                                                Seleccione al menos una opción.
                                                            </div>
                                                        </div>
                                                        <small class="form-text text-muted">Puedes buscar y
                                                            seleccionar una o más
                                                            opciones.</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                                <div class="form-row">
                                    <div class="col-12 text-center space-items-15">

                                        <button class="btn btn-link" type="button"
                                            data-dismiss="modal">Cancelar</button>

                                        <button class="btn btn-outline-primary" type="button"
                                            (click)="prevStepCarousel()">Volver atrás</button>

                                        <button class="btn btn-primary" (click)="validateStepApplicationAddress($event)"
                                            type="button">Continuar</button>
                                    </div>
                                </div>
                            </div>

                            <div class="carousel-item" *ngIf="jobQuestionList.length > 0">


                                <legend class="legend-style-1 legend-primary">
                                    Preguntas del anuncio
                                </legend>

                                <fieldset [formGroup]="_formGroupQuestions" class=" mgn-bottom-25">
                                    <legend class="accesibleHidden">Preguntas para postular</legend>
                                    <div class="form-row">
                                        <div class="col-12">

                                            <div
                                                class="alert alert-warning d-flex font-size-13 mgn-bottom-25 text-dark">
                                                <div class="mgn-rigth-12"><i
                                                        class="pj-ico pj-ico-170 pj-ico-info text-primary"></i>
                                                </div>
                                                <div>El Colegio&nbsp;
                                                    <span class="font-weight-bold">{{employerName}}</span>&nbsp;necesita
                                                    que responda las siguientes preguntas antes de enviar tu
                                                    solicitud de
                                                    postulación:
                                                </div>
                                            </div>

                                            <small class="form-text mgn-bottom-25 text-muted text-right">(*) campos
                                                obligatorios.</small>


                                            <div formArrayName="employerQuestions"
                                                *ngFor="let e of employerQuestions.controls; let i = index;"
                                                class="form-group component-word-counter">
                                                <label for="apply-job-q{{i+1}}">{{i+1}}. {{
                                                    jobQuestionList[i].jobQuestion}} (*)</label>
                                                <textarea [formControlName]="i"
                                                    class="form-control component-content-area messageToPreview"
                                                    rows="4" id="apply-job-q{{i+1}}" placeholder="Escriba su respuesta"
                                                    data-max-word="100" autocomplete="off"
                                                    [ngClass]="{'is-invalid':e.touched && e.invalid}"></textarea>
                                                <div class="invalid-feedback d-block" *ngIf="e.touched && e.invalid">
                                                    Para
                                                    continuar debe
                                                    responder la pregunta.</div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>


                                <div class="form-row">
                                    <div class="col-12 text-center space-items-15">

                                        <button class="btn btn-link" type="button"
                                            data-dismiss="modal">Cancelar</button>

                                        <button class="btn btn-outline-primary" type="button"
                                            (click)="prevStepCarousel()">Volver atrás</button>

                                        <button class="btn btn-primary" (click)="validateStepQuestion($event)"
                                            type="button">Continuar</button>
                                    </div>
                                </div>
                            </div>


                            <div class="carousel-item">

                                <legend class="legend-style-1 legend-primary">
                                    Confirmación de postulación
                                </legend>

                                <div class="form-row">
                                    <div class="col-12">
                                        <p class="font-size-13 mgn-bottom-25">
                                            {{jobQuestionList.length > 0?'¿Está seguro que desea enviar su
                                            postulación
                                            con las siguientes respuestas?':'¿Está seguro que desea enviar su
                                            postulación?'}}
                                        </p>
                                    </div>
                                </div>
                                <div class="form-row"
                                    *ngIf="jobQuestionList.length > 0 || dataAddressSelect.length > 1">
                                    <div class="col-12">
                                        <div class="modal-container-answers-scroll container-gray-200 mgn-bottom-25">
                                            <ng-container *ngIf="dataAddressSelect.length > 1">
                                                <span class="d-inline-block font-weight-bold mgn-bottom-5">Comunas
                                                    a postular</span>
                                                <div class="d-block font-size-13 message-preview mgn-bottom-25">
                                                    {{applicationAddress.value}}</div>
                                            </ng-container>
                                            <ng-container *ngFor="let e of employerQuestions.controls; let i = index; ">
                                                <span class="d-inline-block font-weight-bold mgn-bottom-5">{{i + 1}}.
                                                    {{jobQuestionList[i].jobQuestion}}</span>
                                                <div class="d-block font-size-13 message-preview mgn-bottom-25">
                                                    {{e.value}}</div>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row" [formGroup]="_formGroupConditions"
                                    *ngIf="employeeConditions===false">
                                    <div class="col-12 text-center">
                                        <div class="form-group">
                                            <label
                                                class="checkbox-label font-size-14 mgn-bottom-10 text-left text-muted"
                                                for="agree">
                                                &nbsp;He leído y acepto los
                                                <a [routerLink]="'/'+[constantsService.BASE_PATH_EMPLOYEE_TERM]"
                                                    target="_blank" class="font-weight-bold"
                                                    title="Ver los términos y condiciones" rel="nofollow">términos y
                                                    condiciones</a>.
                                                <input id="agree" type="checkbox" name="" formControlName="agreeForm">
                                                <span class="checkmark"></span>
                                            </label>
                                            <div class="invalid-feedback d-block"
                                                *ngIf="agreeForm.touched && agreeForm.invalid">
                                                Para continuar debes aceptar términos y condiciones.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-12 text-center space-items-15">

                                        <button class="btn btn-link" type="button"
                                            data-dismiss="modal">Cancelar</button>

                                        <button *ngIf="activeButtonBackJobConfirmation" class="btn btn-outline-primary"
                                            type="button" (click)="prevStepCarousel()">Volver atrás</button>


                                        <button style="min-width: 100px;" class="btn btn-primary"
                                            (click)="applyJob($event)">Sí</button>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item successSlide">
                                <div class="slide-success-msg">
                                    <div class="mgn-bottom-25 row">
                                        <div class="col-12">
                                            <div class="simple-msg-modal text-center">
                                                <h4 class="mgn-bottom-3 simple-msg-heading">Tu postulación se envió
                                                    exitosamente</h4>
                                            </div>
                                            <hr class="mgn-top-0" />
                                            <div class="cta-2 max-width-700 ml-auto mr-auto">
                                                <div class="row">
                                                    <div class="col-12 col-sm-auto text-center">
                                                        <img style="max-width: 150px;" loading="lazy"
                                                            src="images/whatsapp-logo.svg"
                                                            class="cta-main-img mgn-bottom-15"
                                                            alt="ilustración persona comparando su salario"
                                                            width="100%" />
                                                    </div>
                                                    <div class="col-12 col-sm">
                                                        <div class="text-center">
                                                            <h3 class="cta-main-heading">¿Quieres recibir ofertas en tu
                                                                WhatsApp?
                                                            </h3>
                                                            <p>Entérate de nuestras oportunidades antes que el resto
                                                                apretando el siguiente link:
                                                            </p><a (click)="onClickWhastapp()"
                                                                class="btn btn-block-xs btn-primary mgn-bottom-8"
                                                                target="_blank" rel="nofollow"
                                                                href="https://chat.whatsapp.com/FStIVgQLvk2LmpCq9ZGRFi">Ir
                                                                a la comunidad de whatsapp</a>
                                                            <div>
                                                                <a (click)="onClickWhastappLater()" class="btn-link"
                                                                    role="button" data-dismiss="modal">No por el
                                                                    momento</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div
                                                        class="align-items-end col-12 col-lg col-sm d-flex justify-content-lg-center justify-content-sm-center">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item errorSlide">
                                <div class="mgn-bottom-25 row">
                                    <div class="col-12 text-center">
                                        <i
                                            class="blue-ligth-1 d-inline-block mgn-bottom-15 pj-ico  pj-ico-modal-error"></i>
                                        <h4 class="error-alert-heading text-primary">Lo sentimos, ha
                                            ocurrido un error</h4>

                                        <p *ngIf="response.status_code && response.status_code===2"
                                            class="mgn-bottom-25 text-dark">Ya has postulado a este anuncio
                                            anteriormente.</p>

                                        <p class="mgn-bottom-25 text-dark">Presione el botón “Volver a
                                            intentar” para intentarlo otra vez de lo contrario presione
                                            “Cancelar” para abandonar esta operación.</p>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-12 text-center space-items-15">
                                        <a class="btn btn-link" data-dismiss="modal">Cancelar</a>

                                        <a *ngIf="dataAddressSelect.length > 1" class="btn btn-primary"
                                            (click)="resetStepCarousel()">Volver a
                                            intentar</a>
                                        <a *ngIf="1 >= dataAddressSelect.length && jobQuestionList.length > 0"
                                            class="btn btn-primary" (click)="setStepCarousel(1)">Volver a
                                            intentar</a>
                                        <a *ngIf="1 >= dataAddressSelect.length && jobQuestionList.length === 0"
                                            class="btn btn-primary" (click)="setStepCarousel(2)">Volver a
                                            intentar</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>